module.exports = __webpack_public_path__ + "static/media/crown1.0eb74298.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/crown1.png
// module id = 1898
// module chunks = 6